import React from 'react';
import PropTypes from 'prop-types';

import { ListItem as MUIListItem } from '@mui/material';

import { ListItemButton } from './ListItemButton';

// v6 removed ListItem's deprecated `button` prop entirely — in v5 it silently rendered a
// ListItemButton internally; now the caller must render ListItemButton directly. Restored
// here so the 2 real consumers using `<ListItem button onClick={...}>` keep working
// unchanged — ListItemButton accepts the same classes/style/onClick/aria shape.
export const ListItem = ({ button = false, ...props }) => (
  button ? <ListItemButton {...props} /> : <MUIListItem {...props} />
);

ListItem.propTypes = {
  alignItems: PropTypes.oneOf(['flex-start', 'center']),
  button: PropTypes.bool,
  classes: PropTypes.object,
  component: PropTypes.elementType,
  dense: PropTypes.bool,
  disableGutters: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  selected: PropTypes.bool
};

export default ListItem;
